import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Colors, Text } from 'library';
import { refreshMembers, refreshGroup } from './shared/api';
import { IGroupMember, IGroup } from './models';
import MemberInfo from './shared/MemberInfo';
import { Card, Divider, Grid } from '@material-ui/core';
import { useHistory, useParams } from 'react-router';
import { track } from 'shared';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

const useStyles = makeStyles(() => ({
    blue: {
        backgroundColor: Colors.darkNavy,
    },
    container: {
        borderRadius: 18,
        maxWidth: 450,
        flexGrow: 1,
        marginRight: 10,
        marginLeft: 10,
    },
}));

export default function MemberList({ location }: { location: any }) {
    const { id } = useParams<{ id: string }>();
    const [members, setMembers] = useState<IGroupMember[]>([]);
    const [group, setGroup] = useState<IGroup>();
    const history = useHistory();
    const classes = useStyles();

    useEffect(() => {
        if (!location?.state?.groupMembers) {
            refreshMembers(id, setMembers);
        } else {
            setMembers(location.state.groupMembers);
        }
        if (!location?.state?.groupName) {
            refreshGroup(id, setGroup);
        } else {
            setMembers(location.state.groupMembers);
        }
    }, [id, location]);

    function returnToGroup() {
        track('Back to group from member list', { group });
        history.push(`/group/${id}`);
    }

    return (
        <Grid xs={12} container style={{ marginTop: 75 }} direction="row" justify="center">
            <Card className={classes.container}>
                <Grid xs={12} item container direction="row" justify="center">
                    {group ? (
                        <Grid container item style={{ width: '70%' }} justify="center">
                            <Grid container item direction="row" justify="space-between" alignItems="center">
                                <ArrowBackIosIcon
                                    width={15}
                                    style={{ color: Colors.darkNavy }}
                                    onClick={returnToGroup}
                                />
                                <Text
                                    variant="h2"
                                    bold
                                    textStyle={{ margin: 15, textAlign: 'center', maxWidth: '70%' }}
                                >
                                    {group.name} Group Members
                                </Text>
                            </Grid>
                            <Divider
                                style={{ color: Colors.disabledGrey, height: 1, width: '100%', marginBottom: 15 }}
                            />
                        </Grid>
                    ) : null}
                    <Grid style={{ height: '80vh', overflow: 'auto', width: '70%' }}>
                        {members.map((member: IGroupMember) => (
                            <MemberInfo member={member} avatarClasses={`${classes.blue}`} />
                        ))}
                    </Grid>
                </Grid>
            </Card>
        </Grid>
    );
}
